export const carNoValPartial = (value: string): boolean => {
  // 정규식 배열을 통해 각 단계별 유효성 검사
  const regex = /^[가-힣]{2}[0-9]{2}[가-힣]{1}[0-9]{0,4}$/; // 한글 문자 2개 + 공백 + 숫자 2개 + 한글 문자 1개 + 공백 + 숫자 0~4개

  // 입력값이 각 단계의 정규식을 통과하는지 확인
  return regex.test(value);
};

export const egPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})/; //핸드폰 정규식
export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/; //비밀번호 정규식 숫자 + 영문
export const idRegex =
  /[{}[\]\/?.,;:|)*~`!^\-_+<>@#$%&\\=('"\[\]ㄱ-ㅎㅏ-ㅣ가-힣]/g;

// 오늘 날짜 표기
export const todayDate = () => {
  const today = new Date();
  const formattedDate = today
    .toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replace(/\. /g, '.');
  return formattedDate;
};

// 숫자에 쉼표 표시
export const formatNumber = (number: number | string) => {
  const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;
  return isNaN(parsedNumber)
    ? ''
    : new Intl.NumberFormat('ko-KR').format(parsedNumber);
};

// 소수점 표시
export const formatPointNumber = (
  number: number | string,
  decimalPlaces: number = 0,
) => {
  const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;
  return isNaN(parsedNumber)
    ? ''
    : new Intl.NumberFormat('ko-KR', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(parsedNumber);
};

const units = ['', '만', '억', '조', '경'];
const numbers = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
const positions = ['', '십', '백', '천'];

export const numberToKorean = (number: number): string => {
  let result = '';
  let unitPos = 0;
  let currentNumber = number;

  while (currentNumber > 0) {
    const chunk = currentNumber % 10000;
    if (chunk > 0) {
      let chunkResult = '';
      let position = 0;
      let tempChunk = chunk;

      while (tempChunk > 0) {
        const digit = tempChunk % 10;
        if (digit > 0) {
          chunkResult = numbers[digit] + positions[position] + chunkResult;
        }
        tempChunk = Math.floor(tempChunk / 10);
        position++;
      }

      result = chunkResult + units[unitPos] + result;
    }
    currentNumber = Math.floor(currentNumber / 10000);
    unitPos++;
  }

  return result;
};

export const formatPhoneNumber = (value: string) => {
  // 숫자만 남기기
  const cleaned = value.replace(/\D/g, '');

  // 최대 11자리로 잘라내기
  const limited = cleaned.slice(0, 11);

  // 패턴 매칭하여 포맷 적용
  const match = limited.match(/^(\d{3})(\d{3,4})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  // 11자리에 미치지 못하는 경우 그대로 반환
  return limited;
};

// 날짜 변환
// 날짜를 로컬 시간대 기준 'YYYY-MM-DD' 형식으로 변환하는 함수
export const formatLocalDate = (date: Date | null) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 서버에서 넘어온 날짜를 'YYYY-MM-DD' 형식으로 변환
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding leading zero
  const day = ('0' + date.getDate()).slice(-2); // Adding leading zero
  return `${year}-${month}-${day}`;
};

// 서버에서 넘어온 날짜 + 시간을 'YYYY-MM-DD HH:MM:SS' 형식으로 변환
export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding leading zero
  const day = ('0' + date.getDate()).slice(-2); // Adding leading zero
  const hours = ('0' + date.getHours()).slice(-2); // Adding leading zero
  const minutes = ('0' + date.getMinutes()).slice(-2); // Adding leading zero
  const seconds = ('0' + date.getSeconds()).slice(-2); // Adding leading zero
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// 시간을 hh:mm 형식으로 변환하는 함수
export const formatTime = (date: Date | null) => {
  if (!date) return ''; // null일 경우 빈 문자열 반환
  const hours = String(date.getHours()).padStart(2, '0'); // 시간을 2자리로 변환
  const minutes = String(date.getMinutes()).padStart(2, '0'); // 분을 2자리로 변환
  return `${hours}:${minutes}`;
};

// 랜덤 색상을 선택하는 함수
export const getRandomColor = (index: number) => {
  const colors = ['#4E5565', '#437BE6', '#435699']; // 사용할 색상 배열
  return colors[index % colors.length]; // 인덱스가 4 이상일 경우를 대비해 나머지 연산 사용
};
